import { EventEmitter } from "nate-react-api-helpers";
import { useEffect } from "react";
export class PopoutInteractor {
    constructor(name, url) { this.chan = void 0; this.fromServer = new EventEmitter(); this.fromClient = new EventEmitter(); this.window = null; this.url = void 0; this.name = void 0; this.url = url; this.name = name; this.chan = new BroadcastChannel(name); this.chan.addEventListener("message", e => { console.log(e.data.from, e.data.payload); if (e.data.from === "server") {
        this.fromServer.emit(e.data.payload);
    }
    else if (e.data.from === "client") {
        if (e.data.payload === "ping" && this.fromServer.lastValue) {
            this.sendToClient(this.fromServer.lastValue);
            return;
        }
        this.fromClient.emit(e.data.payload);
    } }); }
    sendToClient(input) { console.log("send", input); this.fromServer.emit(input); this.chan.postMessage({ source: "tykel", from: "server", payload: input }); }
    sendToServer(input) { this.chan.postMessage({ source: "tykel", from: "client", payload: input }); }
    close() { if (this.window) {
        try {
            this.window.close();
        }
        catch (e) { }
        this.window = null;
        return;
    } }
    open() { if (this.window && !this.window.closed) {
        this.window.focus();
        return;
    } this.window = window.open(this.url, this.name, `left=50,top=50,width=${Math.min(Math.round(window.screen.availWidth * 3 / 4), 1000)},height=${Math.round(window.screen.availHeight * 2 / 3)}`); window.addEventListener("unload", () => { var _this$window; (_this$window = this.window) === null || _this$window === void 0 ? void 0 : _this$window.close(); }); }
}
export function usePopout(panel) { useEffect(() => { return () => { panel.close(); }; }, [panel]); return panel; }
